/**
 * @file  header/styles.ts
 * @description  header styles
 *
 * @author ogarcia (ozkary)
 *
 */
import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const Footer = styled.footer`
  background: #f0f2f5;
  padding: 0;
  display: inline-block;
  text-align: center;
`;

export const Title = styled.h4`
  font-size: 16px;
  text-transform: uppercase;
  color: #000;
  @media screen and (max-width: 414px) {
    padding: 1.5rem 0;
  }
`;

export const NavLink = styled(Link)`
  display: block;
  margin-bottom: 0.625rem;
  transition: all 0.2s ease-in-out;
  &:hover,
  &:active,
  &:focus {
    color: #15418e;
  }
`;

export const Target = styled.a`
  display: block;
  font-size: 1rem;
  margin-bottom: 0.625rem;
  transition: all 0.2s ease-in-out;
  &:hover,
  &:active,
  &:focus {
    color: #15418e;
  }
`;

export const Extra = styled.section`
  background: transparent;
  position: relative;
  width: 100%;
  padding-right: 25px;
  padding-left: 25px;
  margin-right: auto;
  margin-left: auto;
  padding-bottom: 0;
`;

export const LogoContainer = styled.div`
  display: flex;
  position: relative;
`;

export const Select = styled.div`
  line-height: 24px;
  @media only screen and (min-width: 1024px) {
    padding: 0 10%;
  }
`;

export const Para = styled.div`
  color: rgba(2, 7, 62, 0.8);
  max-width: 340px;
  font-size: 14px;
  width: 100%;
`;

export const Empty = styled.div`
  position: relative;
  height: 53px;
`;

export const FooterContainer = styled.div`
  max-width: 510px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  @media screen and (max-width: 414px) {
    padding: 2rem 0;
    padding-right: 50%;
  }
  div {
    cursor: pointer;
    margin-right: 15px;
    width: 25px;
    height: 25px;
    &:hover {
      fill: rgb(255, 130, 92);
    }
  }
`;

export const Hidden = styled.div`
  display: contents;
  width: 100%;
  @media screen and (max-width: 414px) {
    display: none;
  }
`;

export const Label = styled.label`
  font-size: 14px;
  text-transform: uppercase;
  color: #fff;
  display: block;
  margin-top: 1rem;
  margin-bottom: 1.2rem;
  @media screen and (max-width: 414px) {
    padding: 1.5rem 0;
    margin-bottom: 0.5rem;
  }
`;

export const Version = styled.label`
  font-size: 14px;
  text-transform: uppercase;
  color: #fff;
  display: block;
  margin: 5px;
`;

export const A = styled.a`
  color: white;
`;

export const Gold = styled.a`
  color: #b19559;
  font-weight: 600;
  font-size: 1.3rem;
`;
